export function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="plus">
        <path
          id="Icon"
          d="M8.00065 3.3335V12.6668M3.33398 8.00016H12.6673"
          stroke={props.color || '#4D4DFF'}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default PlusIcon;
